module.exports = __webpack_public_path__ + "img/background.55a76236.jpg";